export enum localStorageKeys {
  JWT = "app:token",
  Refresh = "app:refresh",
  themeMode = "app:mode",
  MT = "app:mt_token",
}
